import Router from './routers/Router';

import './assets/i18n';
import './assets/scss/global.scss';
import 'swiper/scss';
import 'swiper/scss/pagination';

const App = () => {
  return <Router />;
};

export default App;
